module.exports = __webpack_public_path__ + "f389ba99d5bd9f587b105ca04ada7b38.svg";